import React, { useEffect, useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { company } from '../mock';

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1500);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;
  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40">
      {open && (
        <div className="mb-3 w-72 bg-white rounded-xl shadow-2xl overflow-hidden animate-in">
          <div className="bg-brand-green text-white p-4 flex items-start justify-between">
            <div>
              <p className="font-bold">Magic Deumidificazioni</p>
              <p className="text-xs text-white/85">Solitamente risponde in pochi minuti</p>
            </div>
            <button onClick={() => setOpen(false)} aria-label="Chiudi chat"><X className="w-4 h-4" aria-hidden="true" /></button>
          </div>
          <div className="p-4 bg-gray-50">
            <div className="bg-white rounded-lg p-3 shadow-sm text-sm text-gray-700">
              Ciao! Come possiamo aiutarti? Hai un&rsquo;emergenza?
            </div>
          </div>
          <a href={company.whatsappLink} target="_blank" rel="noreferrer noopener" aria-label="Avvia chat su WhatsApp" className="block bg-brand-green hover:brightness-110 text-white text-center font-semibold py-3 transition-all">
            Avvia chat su WhatsApp
          </a>
        </div>
      )}
      <button onClick={() => setOpen(!open)} aria-label={open ? 'Chiudi chat WhatsApp' : 'Apri chat WhatsApp'} aria-expanded={open} className="w-14 h-14 rounded-full bg-brand-green text-white shadow-2xl flex items-center justify-center hover:scale-110 transition-transform pulse-red">
        <MessageCircle className="w-7 h-7" aria-hidden="true" />
      </button>
      {!open && (
        <span className="absolute -top-1 -right-1 bg-brand-red text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">1</span>
      )}
    </div>
  );
};

export default WhatsAppFloat;
